import { render, staticRenderFns } from "./AvatarComponent.vue?vue&type=template&id=51cda8be&scoped=true&"
import script from "./AvatarComponent.vue?vue&type=script&lang=js&"
export * from "./AvatarComponent.vue?vue&type=script&lang=js&"
import style0 from "./AvatarComponent.vue?vue&type=style&index=0&id=51cda8be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cda8be",
  null
  
)

export default component.exports